var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGate = function SvgGate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    viewBox: "0 0 128 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M105.994 120.004V50.003C105.994 26.808 87.192 8 63.997 8S22 26.802 22 50.003v70.001h23.797V50.003c0-10.035 8.165-18.2 18.2-18.2s18.2 8.165 18.2 18.2v70.001H106z"
  })));
};
export default SvgGate;